import { v4 as uuid } from "uuid";

interface UpdateObjectKeysInput {
  object: object;
  keyToReplace: string;
  keysToInclude?: string[];
}

export function updateObjectKeys({
  object,
  keyToReplace,
  keysToInclude,
}: UpdateObjectKeysInput) {
  const entries = Object.entries(object).reduce((acc: any[], [key, value]) => {
    if (key === keyToReplace) {
      acc.push([keyToReplace, uuid()]);
    } else if (Array.isArray(value) && keysToInclude?.includes(key)) {
      acc.push([
        key,
        value.map((v, i) => {
          return updateObjectKeys({
            object: object[key][i],
            keyToReplace,
          });
        }),
      ]);
    } else if (
      value &&
      typeof value === "object" &&
      keysToInclude?.includes(key)
    ) {
      acc.push([
        key,
        updateObjectKeys({
          object: object[key],
          keyToReplace,
        }),
      ]);
    } else {
      acc.push([key, value]);
    }

    return acc;
  }, []);

  const filtered = Object.fromEntries(entries);

  return filtered;
}
